import { render } from "./NavAccessoryCard.vue?vue&type=template&id=ba6ab5d4&scoped=true"
import script from "./NavAccessoryCard.vue?vue&type=script&lang=js"
export * from "./NavAccessoryCard.vue?vue&type=script&lang=js"

import "./NavAccessoryCard.vue?vue&type=style&index=0&id=ba6ab5d4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba6ab5d4"]])

export default __exports__